import styled, { css } from 'styled-components';
import { colors, isDefaultThemeMode } from 'core/theme';
import { media } from 'core/layout';

const height = ({compact}) => (
  compact ? 180 : 208
);

export const ThumbnailBase  = styled.section`
  flex: 0 0 auto;
  overflow: hidden;

  ${props => isDefaultThemeMode(props) && css`
    background-color: ${colors.HIGHLIGHT};
  `};

  ${props => isDefaultThemeMode(props) && css`
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  `};

  ${({fixedRatio}) => !fixedRatio && css`
    height: ${height}px;
  `};

  ${media.tabletSmall`
    width: 100%;
  `};

  @media print {
    height: auto;
  }
`;



// WEBPACK FOOTER //
// ./src/elements/Card/components/Thumbnail/styled.js